import React from "react";
import type { AppMode } from "../hooks/useTranslator";
import { useUiLang } from "../../../context/UiLangContext";

interface HeaderLangSelectorsProps {
  appMode: AppMode;
  recording: boolean;
  srcLang: string;
  tgtLang: string;
  fromLabel: string;
  toLabel: string;
  minutaInLabel: string;
  setSrcLang: (lang: string) => void;
  setTgtLang: (lang: string) => void;
  isNarrow?: boolean;
}

const selectStyle = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' fill='none'%3E%3Cpath d='M1 1l3 3 3-3' stroke='%23aaa' stroke-width='1.2' stroke-linecap='round'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat" as const,
  backgroundPosition: "right 7px center",
};

export const HeaderLangSelectors: React.FC<HeaderLangSelectorsProps> = ({
  appMode,
  recording,
  srcLang,
  tgtLang,
  fromLabel,
  toLabel,
  minutaInLabel,
  setSrcLang,
  setTgtLang,
  isNarrow = false,
}) => {
  const { uiLang } = useUiLang();
  const isEn = uiLang === "en";

  return (
    <div className="flex items-center gap-1 flex-shrink-0">
      {!isNarrow && (
        <span className="text-xs font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{fromLabel}</span>
      )}
      <select
        value={srcLang}
        onChange={(e) => setSrcLang(e.target.value)}
        disabled={recording}
        aria-label={isEn ? "Source language" : "Idioma de origen"}
        className="font-sans text-xs font-[500] bg-white dark:bg-[var(--surface)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-2 pr-5 h-[27px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--bg4)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={selectStyle}
      >
        <option value="auto">{isNarrow ? "Auto" : (isEn ? "Auto-Detect" : "Auto-Detectar")}</option>
        <option value="en">{isNarrow ? "EN" : (isEn ? "English" : "Inglés")}</option>
        <option value="es">{isNarrow ? "ES" : (isEn ? "Spanish" : "Español")}</option>
      </select>
      <span className="text-xs text-[var(--text-dim)] mx-0.5">→</span>
      {!isNarrow && (
        <span className="text-xs font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{toLabel}</span>
      )}
      <select
        value={tgtLang}
        onChange={(e) => setTgtLang(e.target.value)}
        disabled={recording}
        aria-label={isEn ? "Target language" : "Idioma de destino"}
        className="font-sans text-xs font-[500] bg-white dark:bg-[var(--surface)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-2 pr-5 h-[27px] min-w-[60px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--bg4)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={selectStyle}
      >
        <option value="es">{isNarrow ? "ES" : (isEn ? "Spanish" : "Español")}</option>
        <option value="en">{isNarrow ? "EN" : (isEn ? "English" : "Inglés")}</option>
      </select>
    </div>
  );
};
